import { useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import Button from "../../../../ui/Button";
import { EditIcon } from "../../../../utils/icon.utils";
import VehicleShowroomWorksViewCard, {
  InventoryViewCardSkeleton
} from "./VehicleShowroomWorksViewCard";
import VehicleShowroomWorkList from "./VehicleShowroomWorkList";
import VehicleInventoryPrint from "./VehicleShowroomWorksPrint";
import VehicleShowroomWorksDate from "./VehicleShowroomWorksDate";

export default function VehicleShowroomWorksView({ data }) {
  const navigate = useNavigate();

  const attachment = data?.attachment;
  const workDate = data?.attachment?.assigned_person;
  const assignedPerson = data?.po_collector;
  const works = attachment?.works;
  const showroomWorkDate = attachment?.showroomWorkDate;

  const assignedPersonData = [
    {
      label: "Name",
      value: assignedPerson?.name ?? "N/A"
    },
    {
      label: "Designation",
      value: assignedPerson?.designation ?? "N/A"
    },
    {
      label: "Mobile",
      value: assignedPerson?.mobile ?? "N/A"
    }
  ];

  const workDateData = [
    {
      label: "Assigned Date",
      value: workDate?.assigned_date ?? "N/A"
    },
    {
      label: "Deadline Date",
      value: workDate?.deadline ?? "N/A"
    }
  ];

  // handle edit
  function handleEdit() {
    navigate(`/stock-list/showroom-works/${data?.caid ?? ""}/edit`);
  }

  return (
    <div className="bg-light rounded p-3">
      <div className="row g-3">
        <div className="col-12">
          <VehicleShowroomWorksDate data={showroomWorkDate} />
        </div>
        <div className="col-12 col-md-6">
          <VehicleShowroomWorksViewCard data={assignedPersonData} title="Assigned Person" />
        </div>
        <div className="col-12 col-md-6">
          <VehicleShowroomWorksViewCard data={workDateData} title="Work Schedule" />
        </div>

        <div className="col-12">
          <VehicleShowroomWorkList data={works} />
        </div>

        <div className="col-12">
          <div className="text-end">
            <VehicleInventoryPrint data={data} />{" "}
            <Button onClick={handleEdit} name="Edit" icon={EditIcon} />
          </div>
        </div>
      </div>
    </div>
  );
}

// VehicleInventoryView skeleton
export function VehicleInventoryViewSkeleton() {
  return (
    <div className="bg-light rounded p-3">
      <p>
        <Skeleton width={`40%`} />
      </p>
      <div className="row">
        <div className="col-12 col-md-6">
          <InventoryViewCardSkeleton />
        </div>

        <div className="col-12 col-md-6">
          <InventoryViewCardSkeleton />
        </div>

        <div className="col-12">
          <div className="text-end">
            <Skeleton width={`10%`} height={30} />
          </div>
        </div>
      </div>
    </div>
  );
}
